import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-2">
              <span className="font-['Outfit'] text-2xl font-bold text-white tracking-tight">
                LUXEO
              </span>
              <span className="font-['Outfit'] text-2xl font-light text-[#D4AF37]">
                CAR
              </span>
            </Link>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed">
              Location de véhicules premium pour chauffeurs VTC à Marseille et Saint-Victoret.
              Tesla Model Y, Ford Mustang Mach-E et Mercedes Classe V.
            </p>
            <div className="text-[#52525B] text-xs font-['Manrope']">
              <p>SARL LUXEO CAR</p>
              <p>Capital : 5 000 €</p>
              <p>SIREN : 989 521 497</p>
              <p>SIRET : 989 521 497 00010</p>
              <p>RCS Aix-en-Provence</p>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-['Outfit'] text-white font-semibold mb-6 text-sm uppercase tracking-wider">
              Navigation
            </h4>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/"
                  data-testid="footer-link-home"
                  className="footer-link font-['Manrope'] text-sm"
                >
                  Accueil
                </Link>
              </li>
              <li>
                <Link
                  to="/location-vtc"
                  data-testid="footer-link-vtc"
                  className="footer-link font-['Manrope'] text-sm"
                >
                  Location VTC
                </Link>
              </li>
              <li>
                <Link
                  to="/comment-ca-marche"
                  data-testid="footer-link-how"
                  className="footer-link font-['Manrope'] text-sm"
                >
                  Comment ça marche
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  data-testid="footer-link-contact"
                  className="footer-link font-['Manrope'] text-sm"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-['Outfit'] text-white font-semibold mb-6 text-sm uppercase tracking-wider">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span className="font-['Manrope'] text-[#A1A1AA] text-sm">
                  328 Boulevard Paul Raphel<br />
                  13730 Saint-Victoret
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#D4AF37] flex-shrink-0" />
                <a
                  href="tel:0620202996"
                  data-testid="footer-phone"
                  className="footer-link font-['Manrope'] text-sm"
                >
                  06 20 20 29 96
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#D4AF37] flex-shrink-0" />
                <a
                  href="mailto:luxeocar@gmail.com"
                  data-testid="footer-email"
                  className="footer-link font-['Manrope'] text-sm"
                >
                  luxeocar@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-['Outfit'] text-white font-semibold mb-6 text-sm uppercase tracking-wider">
              Horaires
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <div className="font-['Manrope'] text-[#A1A1AA] text-sm">
                  <p>Lun - Ven: 9h - 18h</p>
                  <p>Sam: 10h - 16h</p>
                  <p>Dim: Fermé</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-['Manrope'] text-[#52525B] text-sm">
            © {currentYear} Luxeo Car. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/cgv"
              data-testid="footer-cgv"
              className="footer-link font-['Manrope'] text-xs"
            >
              Conditions Générales
            </Link>
            <Link
              to="/confidentialite"
              data-testid="footer-privacy"
              className="footer-link font-['Manrope'] text-xs"
            >
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
